var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45376 13.1762V15.9862C4.45376 16.7162 4.85376 17.3962 5.49376 17.7462L10.4938 20.4762C11.0938 20.8062 11.8138 20.8062 12.4138 20.4762L17.4138 17.7462C18.0538 17.3962 18.4538 16.7162 18.4538 15.9862V13.1762L12.4138 16.4762C11.8138 16.8062 11.0938 16.8062 10.4938 16.4762L4.45376 13.1762ZM10.4938 3.51625L2.06376 8.11624C1.37376 8.49624 1.37376 9.49625 2.06376 9.87625L10.4938 14.4762C11.0938 14.8062 11.8138 14.8062 12.4138 14.4762L20.4538 10.0862V15.9962C20.4538 16.5462 20.9038 16.9962 21.4538 16.9962C22.0038 16.9962 22.4538 16.5462 22.4538 15.9962V9.58625C22.4538 9.21625 22.2538 8.88624 21.9338 8.70624L12.4138 3.51625C11.8138 3.19625 11.0938 3.19625 10.4938 3.51625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.cc96a7d9ca40a0c5ab8980b4e5bdb65f.svg";
export { ForwardRef as ReactComponent };